



































































import { Component, Vue, Watch } from 'vue-property-decorator';
import SellerComission from '@/components/SellerComission.vue';
import Slider from '@/components/forms/Slider.vue';
import Card from '@/components/ui/Card.vue';
import Loader from '@/components/Loader.vue';
import Seller from '@/domain/sellers/Seller';
import sellers from '@/domain/sellers/sellers';

const SellerBarComparisonChart = () =>
  ({
    component: import(/* webpackChunkName: "charting" */ '@/components/SellerBarComparisonChart.vue'),
    loading: Loader,
  } as any);

const SellerLineComparisonChart = () =>
  ({
    component: import(/* webpackChunkName: "charting" */ '@/components/SellerLineComparisonChart.vue'),
    loading: Loader,
  } as any);

@Component({
  components: {
    SellerComission,
    SellerBarComparisonChart,
    SellerLineComparisonChart,
    Slider,
    Card,
  },
})
export default class Home extends Vue {
  public price = 80;
  public hours = 10;
  public sellers = sellers;

  get buildTime() {
    return new Date(process.env.BUILD_TIME).toLocaleString('is-IS');
  }

  get translatedPrice(): number {
    return this.price * 1_000_000;
  }

  get sellersByPrice(): Seller[] {
    return this.sellers
      .slice(0)
      .sort(
        (a, b) =>
          a.totalFee(this.translatedPrice, this.hours) -
          b.totalFee(this.translatedPrice, this.hours),
      );
  }

  get rootClass(): { [classes: string]: boolean } {
    return {
      'bg-white shadow-md': window.self === window.top,
    };
  }
}
